<div class="lcl-quote-container" #elementView>
  <div class="lcl-quote-wrapper">
    <h3 class="lcl-quote-header d-none d-xl-block">{{ "GET_INSTANT_QUOTE" | translate }}</h3>

    <lcl-external-quote-notification
      class="d-none d-xl-block"
      *ngIf="isShowQuoteSubmitNotification"
      (close)="onCloseSendNotification()"
    ></lcl-external-quote-notification>

    <div class="lcl-quote-inputs-wrapper">
      <div class="lcl-quote-inputs-header">
        <div class="lcl-quote-inputs-from-to">
          <lcl-external-quote-notification
            class="d-xl-none"
            *ngIf="isShowQuoteSubmitNotification"
            (close)="onCloseSendNotification()"
          ></lcl-external-quote-notification>

          <app-lcl-create-quote-from-to-updated
            [departurePortFc]="departurePortFc"
            [arrivalPortFc]="arrivalPortFc"
            [isSubmitted]="isSubmitted"
            [isExternal]="true"
            (onSelectFromPort)="onSelectFromPort($event)"
            (onSelectToPort)="onSelectToPort($event)"
            (onSearch)="onStartSearch()"
            (onClear)="onStartSearch()"
          ></app-lcl-create-quote-from-to-updated>
        </div>

        <div class="lcl-quote-inputs-packages-sum">
          <h3 class="lcl-quote-inputs-packages-sum-header">{{ "LCL_SHIPMENT.QUOTE.CREATE.WHAT_ARE_YOU_SHIPPING" | translate }}</h3>

          <div class="lcl-quote-inputs-packages-sum-input" (click)="setIsAddingPackages(true)">
            <span class="lcl-quote-inputs-packages-sum-input-placeholder" *ngIf="!isShowLoadTotals">
              {{ "ENTER_LOAD_DETAILS" | translate }}
            </span>

            <span class="lcl-quote-inputs-packages-sum-input-values" *ngIf="isShowLoadTotals">
              <span class="lcl-quote-inputs-packages-sum-input-values-item">{{ totalWeight }} {{ "WEIGHT_UNIT.KG" | translate }},</span>
              <span class="lcl-quote-inputs-packages-sum-input-values-item ml-1">{{ totalValue }} {{ "LENGTH_UNIT.CBM" | translate }}</span>
            </span>
          </div>
        </div>

        <div class="lcl-quote-inputs-submit">
          <button type="button" class="btn btn-primary lcl-quote-inputs-submit-button" (click)="onSubmit()">
            <span class="d-flex align-items-center justify-content-center">
              {{ "GET_YOUR_QUOTE" | translate }}
              <img class="ml-2" src="assets/icons/icon_arrow_right_white.svg" />
            </span>
          </button>
        </div>
      </div>

      <div class="lcl-quote-inputs-body" *ngIf="isAddingPackages">
        <h3 class="lcl-quote-inputs-packages-sum-header d-xl-none" *ngIf="isFormEdited || !isEmptyPackages">
          {{ "LCL_SHIPMENT.QUOTE.CREATE.WHAT_ARE_YOU_SHIPPING" | translate }}
        </h3>

        <lcl-route-warning
          class="d-none d-xl-block"
          *ngIf="isShowRouteWarning"
          [emailFc]="emailFc"
          [nameFc]="nameFc"
          [passwordFc]="passwordFc"
          [customerNotesFc]="customerNotesFc"
          [errors]="errors"
          [isWithForm]="true"
          [isWithEmailAndName]="true"
          [isShowUserExists]="isShowUserExistsNotification"
          [isButtonDisabled]="customerNotesFc.disabled"
          [isExternal]="true"
          (close)="onCloseRouteWarning()"
          (notesSubmit)="onNotesSubmit()"
        ></lcl-route-warning>

        <div class="lcl-quote-inputs-body-packages">
          <app-lcl-create-quote-packages
            #packagesView
            *ngIf="recalcForm"
            [packagesFormArray]="packagesFormArray"
            [isExternal]="true"
            [isInCard]="false"
            (addPackage)="addPackage()"
            (confirmPackage)="confirmPackage()"
            (removePackage)="removeQuote($event)"
          ></app-lcl-create-quote-packages>
        </div>
      </div>

      <div class="lcl-quote-inputs-footer d-xl-none">
        <h3 class="lcl-quote-inputs-footer-packages-header d-xl-none" *ngIf="!isAddingPackages">
          {{ "LCL_SHIPMENT.QUOTE.CREATE.WHAT_ARE_YOU_SHIPPING" | translate }}
        </h3>

        <button
          type="button"
          class="lcl-quote-inputs-footer-add-package-mobile"
          *ngIf="!isAddingPackages || !isFormEdited"
          [disabled]="isShowRouteWarning"
          (click)="addLoadDetails()"
        >
          <div class="icon-plus-container">
            <icon-plus></icon-plus>
          </div>
          {{ "ADD_LOAD_DETAILS" | translate }}
        </button>

        <div class="lcl-quote-inputs-footer-line"></div>

        <div class="lcl-quote-inputs-footer-warning">
          <lcl-route-warning
            class="d-xl-none"
            *ngIf="isShowRouteWarning"
            [emailFc]="emailFc"
            [nameFc]="nameFc"
            [passwordFc]="passwordFc"
            [customerNotesFc]="customerNotesFc"
            [errors]="errors"
            [isWithForm]="true"
            [isWithEmailAndName]="true"
            [isShowUserExists]="isShowUserExistsNotification"
            [isButtonDisabled]="customerNotesFc.disabled"
            [isMobile]="true"
            [isExternal]="true"
            (close)="onCloseRouteWarning()"
            (notesSubmit)="onNotesSubmit()"
          ></lcl-route-warning>
        </div>

        <div class="lcl-quote-inputs-footer-packages-totals d-xl-flex" [ngClass]="{ 'd-none': isFormEdited }">
          <p class="lcl-quote-inputs-footer-packages-totals-header">{{ "LABELS.TOTALS" | translate }}: {{ totalUnits }}</p>

          <span class="lcl-quote-inputs-footer-packages-totals-sub-header">{{ "LABELS.WEIGHT" | translate }}</span>
          <p class="lcl-quote-inputs-footer-packages-totals-value">{{ totalWeight }} {{ "WEIGHT_UNIT.KG" | translate }}</p>

          <span class="lcl-quote-inputs-footer-packages-totals-sub-header">{{ "LABELS.VOLUME" | translate }}</span>
          <p class="lcl-quote-inputs-footer-packages-totals-value">{{ totalValue }} {{ "LENGTH_UNIT.CBM" | translate }}</p>
        </div>

        <button type="button" class="btn btn-primary lcl-quote-inputs-footer-submit-button d-xl-none" (click)="onSubmit()">
          <span class="d-flex align-items-center justify-content-center">
            {{ "GET_YOUR_QUOTE" | translate }}
            <img class="ml-2" src="assets/icons/icon_arrow_right_white.svg" />
          </span>
        </button>
      </div>
    </div>
  </div>

  <re-captcha #captchaRef="reCaptcha" size="invisible" (resolved)="onNotesValidated($event)" [siteKey]="siteKey"></re-captcha>
</div>
